// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xBaC6lwe2D04B8sjYyf7{flex-direction:column;gap:8px;margin-top:32px;margin-left:6px;padding:0 14px;display:flex;overflow-y:scroll}.ZkBnlqTXqwudrPByeMB1{padding:20px 22px}.zQPvbWUmUAqPqq5KV4Ko{padding-left:20px;padding-right:20px}.rioKMRhd4sT80LbpF0SI,.U74sYHYt8KgVTQSV903n{--collapse-container-margin-bottom:0}.jQWfAfbTuOURyEYyAs16{--collapse-container-padding-top:12px;--collapse-container-padding-bottom:32px;--collapse-container-padding-left:0;--collapse-container-padding-right:0}.U74sYHYt8KgVTQSV903n{--collapse-container-padding-top:12px;--collapse-container-padding-bottom:32px}.wuvIAUKVbYEwPsNns18U{margin-left:4px;padding:0!important}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"collapseActionsWrapper": `xBaC6lwe2D04B8sjYyf7`,
	"collapseHeader": `ZkBnlqTXqwudrPByeMB1`,
	"footerButtons": `zQPvbWUmUAqPqq5KV4Ko`,
	"collapse": `rioKMRhd4sT80LbpF0SI`,
	"dataCollectionCollapse": `U74sYHYt8KgVTQSV903n`,
	"collapseContent": `jQWfAfbTuOURyEYyAs16`,
	"tooltipButton": `wuvIAUKVbYEwPsNns18U`
};
export default ___CSS_LOADER_EXPORT___;
